import { expertSearchKey } from "./expertSearch.key";
import { getExpertList } from "./expertSearch.api";
import { useQuery } from "react-query";
import { getExpertListRequest } from "./expertSearch.type";

export const useGetExpertList = (params?: getExpertListRequest) => {
    return useQuery({
        queryKey: [expertSearchKey.useGetExpertList, params],
        queryFn: () => getExpertList(params),
    });
};
